<rtr-dialog-wrapper>
  <ng-container title>
    {{ 'AddOrganization.Title' | translate }}
  </ng-container>

  <ng-container content>
    <form [formGroup]="form">
      <rtr-input
        dataCy="organization-name"
        label="AddOrganization.Description"
        placeholder="AddOrganization.Placeholder"
        formControlName="name"
        [errors]="errors"
        [maxLength]="60"
      />

      <mat-slide-toggle formControlName="isInternal" [disableRipple]="true" data-cy="is-internal-toggle">{{
        'AddOrganization.Toggle' | translate
      }}</mat-slide-toggle>
    </form>
  </ng-container>

  <ng-container actions>
    <rtr-button
      type="secondary"
      class="margin-r-s"
      text="InputDialog.Cancel"
      [dataCy]="'cancel-dialog'"
      (click)="cancel()"
    />
    <rtr-button
      type="primary"
      text="AddOrganization.Confirm"
      [dataCy]="'confirm-dialog'"
      [disabled]="form.invalid"
      (click)="confirm()"
    />
  </ng-container>
</rtr-dialog-wrapper>
